import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { TaskSquare } from "../../../../ui/icons/TaskSquare";
import Button from "../../../../ui/molecules/button";
import { NotComparisonUpdateStatusParticelle, setNotStatusTypeParticelleStrutture, setSaveStatusParticelleAlienate, setSaveStatusParticelleInserite } from "./slice";

export function ComparazioneVegetale() {
    const notificationState = useAppSelector(state => state.notification)
    const dispatch = useAppDispatch()
    const selectedNot = notificationState.notificationIdToUpdate;
    const comparisonState = useAppSelector(state => state.NotComparison)
    return (

        <div>
            {
                comparisonState.GetComparisonResponse && (
                    <>
                        <div className="fieldset2-header mt-4">
                            <span className='title'>Differenza di superfici tra notifiche</span>
                        </div>
                        <div className='fieldset2-content'>
                            <div>
                                <table id="list-table" className="w-[100%]">
                                    <thead className="h-[30px] uppercase">
                                        <tr>
                                            <th>Notifica</th>
                                            <th>Sup bio (mq)</th>
                                            <th>Sup Convenz. (mq)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{comparisonState.GetComparisonResponse.currentNotification}</td>
                                            <td>{comparisonState.GetComparisonResponse.parcelAreaComparison.currentNotificationBioArea}</td>
                                            <td>{comparisonState.GetComparisonResponse.parcelAreaComparison.currentNotificationConventionalArea}</td>
                                        </tr>
                                        <tr>
                                            <td>{comparisonState.GetComparisonResponse.previousNotification}</td>
                                            <td>{comparisonState.GetComparisonResponse.parcelAreaComparison.previousNotificationBioArea}</td>
                                            <td>{comparisonState.GetComparisonResponse.parcelAreaComparison.previousNotificationConventionalArea}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="displayFlex gap-3 mt-6 ">
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Particelle inserite con notifica n.</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Belfiore</th>
                                                    <th>Comune</th>
                                                    <th>Foglio</th>
                                                    <th>Particella</th>
                                                    <th>Sup bio (mq)</th>
                                                    <th>Sup convz (mq)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.insertedParcelComparisons.map((insertParcel) =>
                                                        <tr>
                                                            <td>
                                                                {insertParcel.cadastralCode}
                                                            </td>
                                                            <td>
                                                                {insertParcel.city}
                                                            </td>
                                                            <td>
                                                                {insertParcel.sheet}
                                                            </td>
                                                            <td>
                                                                {insertParcel.parcel}
                                                            </td>
                                                            <td>
                                                                {insertParcel.bioArea}
                                                            </td>
                                                            <td>
                                                                {insertParcel.conventionalArea}
                                                            </td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="pt-4 text-left font-bold">
                                        <span>Numero di particelle inserite: {comparisonState.GetComparisonResponse.insertedParcels}</span>
                                    </div>
                                </div>

                            </div>
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Particelle alienate con notifica n.</span>
                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%] particle-table">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Belfiore</th>
                                                    <th>Comune</th>
                                                    <th>Foglio</th>
                                                    <th>Particella</th>
                                                    <th>Sup bio (mq)</th>
                                                    <th>Sup convz (mq)</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    comparisonState.GetComparisonResponse.alienatedParcelComparisons.map((alienatedParcel) =>
                                                        <tr>
                                                            <td>
                                                                {alienatedParcel.cadastralCode}
                                                            </td>
                                                            <td>
                                                                {alienatedParcel.city}
                                                            </td>
                                                            <td>
                                                                {alienatedParcel.sheet}
                                                            </td>
                                                            <td>
                                                                {alienatedParcel.parcel}
                                                            </td>
                                                            <td>
                                                                {alienatedParcel.bioArea}
                                                            </td>
                                                            <td>
                                                                {alienatedParcel.conventionalArea}
                                                            </td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="pt-4 text-left font-bold">
                                        <span>Numero di particelle alienate: {comparisonState.GetComparisonResponse.alienatedParcels}</span>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div>
                            <div>
                                <Button
                                    color="orange"
                                    variant="solid"
                                    iconPosition="left"
                                    icon={<TaskSquare color="#fff" size={24} />}
                                    size="md"
                                    label="Salva nello stato delle notifiche"
                                    onClick={() => {
                                        if (comparisonState.saveUpdateStatusParticelleRequest) {
                                            dispatch(NotComparisonUpdateStatusParticelle(
                                                {
                                                    body: {
                                                        addedInfo: comparisonState.saveUpdateStatusParticelleRequest.addedInfo,
                                                        removedInfo: comparisonState.saveUpdateStatusParticelleRequest.removedInfo,
                                                        officerId: comparisonState.saveUpdateStatusParticelleRequest.officerId,
                                                        variationCausesType: 'PARTICELLE'
                                                    },
                                                    id: comparisonState.currentNotificationStatusId
                                                }
                                            ))
                                        }
                                    }
                                    }
                                />
                            </div>
                        </div>

                        {/* strutture */}

                        <div className="mt-4 pt-2 separator-top-darkGreen">
                            <div style={{ flex: '1', textAlign: 'left' }}>
                                <h3 className="text-heading-sm font-bold sectionTitle">Confronto per le strutture</h3>
                            </div>

                        </div>

                        <div className="displayFlex gap-4  mt-6">
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Strutture inserite con notifica n.</span>

                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Belfiore</th>
                                                    <th>Comune</th>
                                                    <th>Foglio</th>
                                                    <th>Particella</th>
                                                </tr>
                                            </thead>
                                            {
                                                comparisonState.GetComparisonResponse.insertedStructureComparisons.map((insertedParcel) =>
                                                    <tr>
                                                        <td>
                                                            {insertedParcel.cadastralCode}
                                                        </td>
                                                        <td>
                                                            {insertedParcel.city}
                                                        </td>
                                                        <td>
                                                            {insertedParcel.sheet}
                                                        </td>
                                                        <td>
                                                            {insertedParcel.parcel}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </table>
                                        <div className="pt-4 text-left font-bold">
                                            <span>Numero di strutture inserite: {comparisonState.GetComparisonResponse.insertedStructures}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div style={{ flex: '0.5' }}>
                                <div className="fieldset2-header" >
                                    <span className='title'>Strutture alienate con notifica n.</span>
                                </div>
                                <div className='fieldset2-content'>
                                    <div>
                                        <table id="list-table" className="w-[100%]">
                                            <thead className="h-[40px] uppercase">
                                                <tr>
                                                    <th>Belfiore</th>
                                                    <th>Comune</th>
                                                    <th>Foglio</th>
                                                    <th>Particella</th>
                                                </tr>
                                            </thead>
                                            {
                                                comparisonState.GetComparisonResponse.alienatedStructureComparisons.map((alienatedStructure) =>
                                                    <tr>
                                                        <td>
                                                            {alienatedStructure.cadastralCode}
                                                        </td>
                                                        <td>
                                                            {alienatedStructure.city}
                                                        </td>
                                                        <td>
                                                            {alienatedStructure.sheet}
                                                        </td>
                                                        <td>
                                                            {alienatedStructure.parcel}
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </table>
                                        <div className="pt-4 text-left font-bold">
                                            <span>Numero di strutture alienate: {comparisonState.GetComparisonResponse.alienatedStructures}</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                        <div className="mt-6">
                            <div>
                                <Button
                                    color="orange"
                                    variant="solid"
                                    iconPosition="left"
                                    icon={<TaskSquare color="#fff" size={24} />}
                                    size="md"
                                    label="Salva nello stato delle notifiche"
                                    onClick={() => {
                                        if (comparisonState.saveUpdateStatusParticelleRequest) {
                                            dispatch(NotComparisonUpdateStatusParticelle(
                                                {
                                                    body: {
                                                        addedInfo: comparisonState.saveUpdateStatusStruttureRequest.addedInfo,
                                                        removedInfo: comparisonState.saveUpdateStatusStruttureRequest.removedInfo,
                                                        officerId: comparisonState.saveUpdateStatusParticelleRequest.officerId,
                                                        variationCausesType: 'STRUTTURE'
                                                    },
                                                    id: comparisonState.currentNotificationStatusId
                                                }
                                            ))
                                        }
                                    }
                                    }
                                />
                            </div>
                        </div>
                        {/* attività */}
                        <div className="mt-4 pt-4 gap-2 separator-top-darkGreen" style={{ flex: 1 }}>
                            <div className="fieldset2-header">
                                <span className='title'>Differenza fra le attività</span>
                            </div>
                            <div className='fieldset2-content'>
                                <div>
                                    <table id="list-table" className="w-[100%]">
                                        <thead className="h-[40px] uppercase">
                                            <tr>
                                                <th>Notifica</th>
                                                <th>Attività</th>
                                                <th>Specifiche</th>
                                            </tr>
                                        </thead>
                                        <tbody>

                                            <tr>
                                                <td>{comparisonState.GetComparisonResponse.currentNotification}</td>
                                                <td>{comparisonState.GetComparisonResponse.currentNotificationActivity}</td>
                                                <td>{comparisonState.GetComparisonResponse.currentNotificationSpecification}</td>
                                            </tr>
                                            <tr>
                                                <td>{comparisonState.GetComparisonResponse.previousNotification}</td>
                                                <td>{comparisonState.GetComparisonResponse.previousNotificationActivity}</td>
                                                <td>{comparisonState.GetComparisonResponse.previousNotificationSpecification}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="pt-4 text-left font-bold">
                                        <div><span>{comparisonState.GetComparisonResponse.activityDifference}</span></div>
                                        <div><span>{comparisonState.GetComparisonResponse.specificationDifference}</span></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* differenza superfici */}

                        <div className="mt-6 pt-6  separator-top-darkGreen gap-2" style={{ flex: 1 }}>
                            <div className="fieldset2-header">
                                <span className='title'>Differenza di superfici tra le particelle catastali delle due notifiche</span>
                            </div>
                            <div className='fieldset2-content'>
                                <div>
                                    <table id="list-table" className="w-[100%]">
                                        <thead className="h-[40px] uppercase">
                                            <tr>
                                                <th>Belfiore</th>
                                                <th>Comune</th>
                                                <th>Foglio</th>
                                                <th>Particella</th>
                                                <th>Diffrenza somme bio(mq)</th>
                                                <th>Diffrenza somme convz(mq)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                comparisonState.GetComparisonResponse.parcelComparisons.map((parcel) =>
                                                    <tr>
                                                        <td>{parcel.cadastralCode}</td>
                                                        <td>{parcel.city}</td>
                                                        <td>{parcel.sheet}</td>
                                                        <td>{parcel.parcel}</td>
                                                        <td>{parcel.bioArea}</td>
                                                        <td>{parcel.conventionalArea}</td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </>
                )
            }
            {/* HEADER */}

        </div>
    )
}